import { Badge, Group, Text } from '@mantine/core';
import { IconStar } from '@sloyd/icons';
import { numeric } from 'shared-base';
import styles from './Credits.module.css';
import { Wrapper } from './Credits.style';

export type CreditsProps = {
  user: IUser;
};

export function Credits(props: CreditsProps) {
  const { user } = props;
  const { planName, credits } = user;

  function renderCredits() {
    return (
      <Group gap='xs' className={styles.credits}>
        <Text size='sm' fw={500} c='dimmed'>
          Credits:
        </Text>
        <Text size='lg' fw={700} c='blue'>
          {!credits ? '-' : numeric(credits)}
        </Text>
      </Group>
    );
  }

  return (
    <Wrapper className='Credits-wrapper' data-testid='Credits-wrapper'>
      <Group className={styles.wrapper} align='center'>
        <Group gap='sm'>
          <Badge color='blue' size='sm' leftSection={<IconStar size={14} />}>
            {planName}
          </Badge>
        </Group>
        {/* {renderCredits()} */}
      </Group>
    </Wrapper>
  );
}

export default Credits;
